export const NEXT_REVALIDATION_ROUTE = "/api/revalidate";
export const SERVER_TRPC_BASE_PATH = "/_new/trpc";
